import TagSwitchesSource from "../libs/filters/TagSwitchesSource";
import 'bootstrap-datepicker'
import {GroupsListFilter} from "../libs/filters/groupsListFilter";
import SearchFilterSource from "../libs/filters/SearchFilterSource";
import {cl} from "@fullcalendar/core/internal-common";
import FilterButtonDataSource from "../libs/filters/DataSource";

const moment = require('moment');

export default function (context) {

    // on-page tag switches
    const tagButtons = $('.tags-list li[data-filter-by="tag"]', context)
    const switches = new TagSwitchesSource(tagButtons)
    tagButtons.children('a').click(function () {
        const parent = $(this).parent();
        switches.switch(parent)
        if($(this).closest('.tag-group-list,.tag-group-modal').length && parent.hasClass('selected')){
            addChecked(parent.data('filter'))
        }else{
            removeChecked(parent.data('filter'),parent)
        }
        // markCheckedTags($(this), parent);
        saveFilters();
        return false
    });
    let searches = []
    // Simple search
    $('.search-simple', context).each(function(){
        $(this).off('keyup input')
        .on('keyup input', function onkeyup(e) {
            if (onkeyup.timer) {
                clearTimeout(onkeyup.timer)
            }
            onkeyup.timer = setTimeout(() => {
                simpleSearch.trigger('update')
            }, 1000)
        })
        const simpleSearch = new SearchFilterSource($(this))
        searches.push(simpleSearch)
    })


    const resetSlider = function (wrapper) {
        wrapper.attr("data-pos", 0);
        wrapper.find(".scroll-slider").eq(0).css("transform", "translateX(0)");
    }

    const setFilters = function(panel, container, enabled = true) {
        if (panel.length) {
            const fixed = new FilterButtonDataSource(panel, 'forceTags')
            panel.data('filter', (new GroupsListFilter(
                {
                    container: container,
                    enabled: enabled,
                    sources: [fixed, switches, ...searches],
                    emptyMessageBox: $('.no-results', panel),
                    pagination: {
                        enabled: panel.hasClass('pagination'),
                        pageSize: panel.find('.scroll-wrapper').data('cols') || 4,
                        button: $('.more-button', panel)
                    }
                }
                ))
                    .clear()
                    .on('update', () => {
                        resetSlider($('.scroll-wrapper', panel).eq(0))
                        window.calcScrolls()
                    })
                    .on('clear', window.calcScrolls)
            )
        }
    }

    setFilters($('#panel__regular-groups', context), $('.activities-list'), $('.activities-list').hasClass('filter-enabled'))
    setFilters($('#panel__checking-groups', context), $('.quick-links-list'), $('.quick-links-list').hasClass('filter-enabled'))
    setFilters($('#panel__parent-groups', context), $('#panel__parent-groups').find('.communities-list'), $('#panel__parent-groups').find('.communities-list').hasClass('filter-enabled'))
    setFilters($('#panel__marked_parent-groups', context), $('#panel__marked_parent-groups').find('.communities-list'), $('#panel__marked_parent-groups').find('.communities-list').hasClass('filter-enabled'))

    $('.page-tabs').each(function () {
        const filter = $($(this).data('target')).data('filter')
        if (filter instanceof GroupsListFilter) {
            const switches = new TagSwitchesSource($(this).find('input[type="radio"]'))

            $(this).find('.date-select').datepicker({
                clearBtn: true,
                autoclose: true,
                container: "#bootstrapWidgetsContainer",
            }).on('changeDate', function (e) {
                if (e.date !== undefined) {
                    const $this = $(this)
                    const target = $($this.data('target'))
                    const date = moment(e.date)
                    $this.text(date.format('DD/MM/YYYY'))
                    target.data($this.data('var'), date.unix())
                    switches.switch()
                }
            }).on('clearDate', function (e) {
                const $this = $(this)
                const target = $($this.data('target'))
                $this.text($this.data('empty_text'))
                target.data($this.data('var'), null)
                switches.switch()
            })
            $(this).find('input[name="page-tabs"]').change(() => {
                switches.switch()
            })
            filter.addSource(switches)
        }
    })

    const addChecked = function(key){
        let link = document.createElement('a');
        link.text = key;
        link.href = "#";
        link.dataset.filter = key;
        link.role = "button";
        link.ariaLabel = translate.tags.remove_tag.replace('%', key)
        link.onclick = function() { removeChecked(this.dataset.filter,this); return false; };
        $('.tag-groups-checked').append(link);
    }

    const  removeChecked = function(key,el = null){
        $('.tag-groups-checked [data-filter="'+key+'"],.triggered[data-filter="'+key+'"]').remove();
        if(el.tagName == "a" || el.tagName == "A"){
            switches.switch($('.tags-list li.selected[data-filter="'+key+'"]'));
        }
    }

    // const markCheckedTags = (element,parent) => {
        // markCheckedGroup('.map-mobile-filters');
        // markCheckedGroup('.map-filters');
    // }

    // const markCheckedGroup = (element) => {
    //     $(element+' .tags-list').each(function () {
    //         if($(this).find('li.selected').length){
    //             $(element+' [data-group="'+$(this).attr('data-filters')+'"]').parent().addClass('selected');
    //         }else{
    //             $(element+' [data-group="'+$(this).attr('data-filters')+'"]').parent().removeClass('selected');
    //         }
    //     })
    // }

    const saveFilters = () => {
        let url = new URL(location);
        let filterList = jQuery.map($("li.selected"), (e) => $(e).data('filter')).join(',');
        if (filterList) {
            if (history.pushState) {
                url.searchParams.set('filter', filterList);
                history.pushState(null, null, url);
            }
        } else {
            if (history.pushState) {
                history.pushState(null, null, url.origin + url.pathname);
            }
        }
    }

    const loadFilters = () => {
        let url = new URL(location);
        let filters = url.searchParams.get("filter");
        if (filters) {
            let filtersArray = filters.split(',');
            filtersArray.forEach(function (el) {
                if (window.innerWidth > 768) {
                    $(`li[data-filter="${el}"]`).first().find('a').click();
                } else {
                    $(`li[data-filter="${el}"]`).last().find('a').click();
                }
            });
        }
    }
    if (context === document) {
        loadFilters()
    }
}
